import React, { Component , Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
const Home = React.lazy(() => import('./Components/Home'));
const PageNotFound = React.lazy(() => import('./Components/404'));
const ServerErorrPage = React.lazy(() => import('./Components/500'));
const PostDetails = React.lazy(() => import('./Components/PostDetails'));
const ConferenceCalendar = React.lazy(() => import('./Components/ConferenceCalendar'));
const LegalPerson = React.lazy(() => import('./Components/LegalPerson'));
const Citation = React.lazy(() => import('./Components/Citation'));
const Conferences = React.lazy(() => import('./Components/Conferences'));
const Document = React.lazy(() => import('./Components/Document'));
const Search = React.lazy(() => import('./Components/Search'));
const SearchIsi = React.lazy(() => import('./Components/SearchIsi'));
const Thesis = React.lazy(() => import('./Components/Thesis'));
const Journals = React.lazy(() => import('./Components/Journals'));
const Meetings = React.lazy(() => import('./Components/Meetings'));
const Support = React.lazy(() => import('./Components/Support'));
const Register = React.lazy(() => import('./Components/Register'));
const Rememmber = React.lazy(() => import('./Components/Rememmber'));
const Scientometrics = React.lazy(() => import('./Components/Scientometrics'));
const OrganList = React.lazy(() => import('./Components/OrganList'));
const Stats = React.lazy(() => import('./Components/Stats'));
const RegisterConference = React.lazy(() => import('./Components/RegisterConference'));
const RegisterJournal = React.lazy(() => import('./Components/RegisterJournal'));
const RegisterMeeting = React.lazy(() => import('./Components/RegisterMeeting'));
const CreditTransfer = React.lazy(() => import('./Components/CreditTransfer'));
const Certificate = React.lazy(() => import('./Components/Certificate'));
const CertificateHome = React.lazy(() => import('./Components/CertificateHome'));
const Provinces = React.lazy(() => import('./Components/Provinces'));
const Province = React.lazy(() => import('./Components/Province'));
const City = React.lazy(() => import('./Components/City'));
const Posts = React.lazy(() => import('./Components/Posts'));
const PostsLanding = React.lazy(() => import('./Components/PostsLanding'));
const Resume = React.lazy(() => import('./Components/Resume'));
const LegalList = React.lazy(() => import('./Components/LegalList'));
const Events = React.lazy(() => import('./Components/Events'));
const EventsDetails = React.lazy(() => import('./Components/EventsDetails'));
const RegisterRecall = React.lazy(() => import('./Components/RegisterRecall'));
const AccountHome = React.lazy(() => import('./Components/AccountProfile'));
const AccountFinancial = React.lazy(() => import('./Components/AccountFinancial'));
const AccountCash = React.lazy(() => import('./Components/AccountCash'));
const AccountSupportList = React.lazy(() => import('./Components/AccountSupportList'));
const AccountCertificate = React.lazy(() => import('./Components/AccountCertificate'));
const AccountFavorites = React.lazy(() => import('./Components/AccountFavorites'));
const AccountRequest = React.lazy(() => import('./Components/AccountRequests'));
const AccountGiftCards = React.lazy(() => import('./Components/AccountGiftCards'));
const PageRedirect = React.lazy(() => import('./Components/Redirect'));
const UrlRedirect = React.lazy(() => import('./Components/UrlRedirect'));
const DocumentDownload = React.lazy(() => import('./Components/DocumentDownload'));
const InvoiceView = React.lazy(() => import('./Components/InvoiceView'));
const DocumentSend = React.lazy(() => import('./Components/DocumentSend'));
const DocumentComment = React.lazy(() => import('./Components/DocumentComment'));
const UniProf = React.lazy(() => import('./Components/UniProf'));
const UniStd = React.lazy(() => import('./Components/UniStd'));
const Subject = React.lazy(() => import('./Components/Subject'));
const Login = React.lazy(() => import('./Components/Login'));
const Resumes = React.lazy(() => import('./Components/Resumes'));
const AccountQuestionnaire = React.lazy(() => import('./Components/AccountQuestionnaire'));
const AccountQuestionnaires = React.lazy(() => import('./Components/AccountQuestionnaires'));
const Questionnaire = React.lazy(() => import('./Components/Questionnaire'));
const ProfileConfirm = React.lazy(() => import('./Components/ProfileConfirm'));
const Mining = React.lazy(() => import('./Components/Mining'));
const Research = React.lazy(() => import('./Components/Research'));
const PaymentVerify = React.lazy(() => import('./Components/PaymentVerify'));
const CertificateOrderDone = React.lazy(() => import('./Components/CertificateOrderDone'));
const ISIPay = React.lazy(() => import('./Components/ISIPay'));
const ProfileNoteComponent = React.lazy(() => import('./Components/AccountNotes'));
const ProfileNoteFormComponent = React.lazy(() => import('./Components/AccountNote'));
const NotesComponent = React.lazy(() => import('./Components/Notes'));
const NoteComponent = React.lazy(() => import('./Components/Note'));
const NotesLandingComponent = React.lazy(() => import('./Components/NotesLanding'));
const NotesListComponent = React.lazy(() => import('./Components/NotesList'));
const NotesTagComponent = React.lazy(() => import('./Components/NotesTag'));
const AccountComments = React.lazy(() => import('./Components/AccountComments'));
const AccountInvites = React.lazy(() => import('./Components/AccountInvites'));
const AccountPrePrintSubmit = React.lazy(() => import('./Components/AccountPrePrintSubmit'));
const AccountPrePrints = React.lazy(() => import('./Components/AccountPrePrints'));
const PreprintsLanding = React.lazy(() => import('./Components/PreprintsLanding'));

class Site extends Component {
  constructor(props) {
    super(props);
    if (props.dataHolder !== null && props.dataHolder !== undefined)
    {
      this.state = {
        dataHolder:props.dataHolder,
        lang: props.dataHolder.lang
      }
    }
    else{
      var lang = "fa";
      if (window != undefined && window!= null)
        if (window.location.href.indexOf("en.civilica")>=0) lang = "en";
        
      this.state = {
        dataHolder:null,
        query:"",
        civilicaDocumentsCounts: '',
        lang: lang
      }
      try{
        document.getElementById("root").classList="react";
        if (lang === "en") document.getElementsByTagName("html")[0].setAttribute('dir','ltr');
      }catch{}
    }
  }
  render() {
    const dH = this.state.dataHolder;
    return(
      <Suspense fallback={<div></div>}>
        <Routes>
          <Route path="/" dataHolder={dH} element={<Home />}></Route>
          <Route path="/404/" dataHolder={dH} element={<PageNotFound />}></Route>
          <Route path="/500/" dataHolder={dH} element={<ServerErorrPage />}></Route>
          <Route path="/post/:postId/" dataHolder={dH} element={<PostDetails />}></Route>
          <Route path="/calendar/" dataHolder={dH} element={<ConferenceCalendar />}></Route>          
          <Route path="/l/:person_id/web/" dataHolder={dH} element={<PageRedirect/>}></Route>       
          <Route path="/redirect/" dataHolder={dH} element={<UrlRedirect/>}></Route>
          <Route path="/l/:personId/" dataHolder={dH} element={<LegalPerson />}></Route>
          <Route path="/l/:personId/:filters/" dataHolder={dH} element={<LegalPerson />}></Route>          
          <Route path='/citation/:legalPersonId/' dataHolder={dH} element={<Citation/>}></Route>
          <Route path="/posts/:postType/:page/" dataHolder={dH} element={<Posts />}></Route>
          <Route path="/posts/:postType/" dataHolder={dH} element={<Posts />}></Route>
          <Route path="/posts/" dataHolder={dH} element={<PostsLanding />}></Route>
          <Route path="/p/:personId/" dataHolder={dH} element={<Resume inEditMode={0} />}></Route>
          <Route path="/p/:personId/edit/" dataHolder={dH} element={<Resume inEditMode={1} />}></Route>
          <Route path="/p/" dataHolder={dH} element={<Resumes />}></Route>        
          <Route path='/p/ls/:filter/' dataHolder={dH} element={<Resumes />}></Route>
          <Route path='/p/:personId/notes/' dataHolder={dH} element={<NotesComponent />}></Route>
          <Route path='/p/:personId/notes/:page/' dataHolder={dH} element={<NotesComponent />}></Route>        
          <Route path='/note/:id/' dataHolder={dH} element={<NoteComponent />}></Route>
          <Route path='/notes/' dataHolder={dH} element={<NotesLandingComponent />}></Route>
          <Route path='/notes/list/:page/' dataHolder={dH} element={<NotesListComponent />}></Route> 
          <Route path='/notes/tag/:tagId/:page/' dataHolder={dH} element={<NotesTagComponent />}></Route> 
          <Route path='/preprints/' dataHolder={dH} element={<PreprintsLanding />}></Route>                       
          <Route path='/ls/:filter/' dataHolder={dH} element={<LegalList />}></Route>
          <Route path="/conferences/:filter/" dataHolder={dH} element={<Conferences />}></Route>
          <Route path="/conferences/" dataHolder={dH} element={<Conferences />}></Route>
          <Route path='/inv/:request_id/:hash/' dataHolder={dH} element={<InvoiceView/>}></Route>
          <Route path='/doc/media/send/:document_id/' dataHolder={dH} element={<DocumentSend template={1}/>}></Route>
          <Route path='/doc/comment/send/:request_id/:hash/' dataHolder={dH} element={<DocumentComment/>}></Route>
          <Route path="/doc/:paperId/download/" dataHolder={dH} element={<DocumentDownload template={1} />}></Route>
          <Route path="/doc/:paperId/" dataHolder={dH} element={<Document template={1} />}></Route>
          <Route path="/search/paper/:filter/" dataHolder={dH} element={<Search />}></Route>
          <Route path="/search/paper/" dataHolder={dH} element={<Search />}></Route>
          <Route path="/search/isi/:filter/" dataHolder={dH} element={<SearchIsi />}></Route>
          <Route path="/search/isi/" dataHolder={dH} element={<SearchIsi />}></Route>
          <Route path='/isi/media/send/:document_id/' dataHolder={dH} element={<DocumentSend template={2}/>} />
          <Route path="/isi/pay/:request_id/:hash/" dataHolder={dH} element={<ISIPay />}></Route>
          <Route path="/isi/:paperId/download/" dataHolder={dH} element={<DocumentDownload template={2} />}></Route>
          <Route path='/isi/:paperId/' dataHolder={dH} element={<Document template={2} />}></Route>
          <Route path="/thesis/" dataHolder={dH} element={<Thesis />}></Route>
          <Route path="/journals/" dataHolder={dH} element={<Journals />}></Route>
          <Route path="/meetings/" dataHolder={dH} element={<Meetings />}></Route>          
          <Route path='/support/doc/:documentId/' dataHolder={dH} element={<Support />}></Route>
          <Route path='/support/inv/:requestId/' dataHolder={dH} element={<Support />}></Route>
          <Route path='/support/:supportId/' dataHolder={dH} element={<Support />}></Route>
          <Route path="/support/" dataHolder={dH} element={<Support />}></Route>
          <Route path="/register/confrence/" dataHolder={dH} element={<RegisterConference />}></Route>
          <Route path="/register/journal/" dataHolder={dH} element={<RegisterJournal />}></Route>
          <Route path="/register/meeting/" dataHolder={dH} element={<RegisterMeeting />}></Route>
          <Route path="/register/recall/" dataHolder={dH} element={<RegisterRecall />}></Route>          
          <Route path="/register/" dataHolder={dH} element={<Register />}></Route>
          <Route path="/register/:invited_by/" dataHolder={dH} element={<Register />}></Route>          
          <Route path="/Login/" dataHolder={dH} element={<Login />}></Route>
          <Route path="/remember/:token/" dataHolder={dH} element={<Rememmber />}></Route>
          <Route path="/remember/" dataHolder={dH} element={<Rememmber />}></Route>
          <Route path='/subject/:id1/:id2/' dataHolder={dH} element={<Subject />} />
          <Route path='/subject/:id1/' dataHolder={dH} element={<Subject />} />
          <Route path='/subject/' dataHolder={dH} element={<Subject />}/>
          <Route path="/scientometrics/:affType/" dataHolder={dH} element={<Scientometrics />}></Route>
          <Route path="/scientometrics/" dataHolder={dH} element={<Scientometrics />}></Route>
          <Route path="/members/" dataHolder={dH} element={<OrganList />}></Route>
          <Route path="/stats/" dataHolder={dH} element={<Stats />}></Route>
          <Route path="/provinces/" dataHolder={dH} element={<Provinces />}></Route>
          <Route path="/province/:provinceId/" dataHolder={dH} element={<Province />}></Route>
          <Route path="/city/:cityId/" dataHolder={dH} element={<City />}></Route>
          <Route path="/event/:eventId/" dataHolder={dH} element={<EventsDetails />}></Route>
          <Route path='/certificate/request/:paperId/' dataHolder={dH} element={<Certificate />} />
          <Route path="/certificate/" dataHolder={dH} element={<CertificateHome />}></Route>
          <Route path="/events/" dataHolder={dH} element={<Events />}></Route>
          <Route path="/events/:year/:month/:day/" dataHolder={dH} element={<Events />}></Route>
          <Route path="/event/:eventId/" dataHolder={dH} element={<EventsDetails />}></Route>  
          <Route path="/profile/credit/transfer/q/:uuid/" dataHolder={dH} element={<CreditTransfer type={2} />}></Route>
          <Route path="/profile/credit/transfer/" dataHolder={dH} element={<CreditTransfer type={1} />}></Route>
          <Route path="/profile/" dataHolder={dH} element={<AccountHome />}></Route>
          <Route path="/profile/support/" dataHolder={dH} element={<AccountSupportList />}></Route>
          <Route path="/profile/favorites/" dataHolder={dH} element={<AccountFavorites />}></Route>    
          <Route path="/profile/favorites/:page/" dataHolder={dH} element={<AccountFavorites />}></Route>        
          <Route path="/profile/certificate/" dataHolder={dH} element={<AccountCertificate type={1} />}></Route>
          <Route path="/profile/certificate/done/" dataHolder={dH} element={<AccountCertificate type={2} />}></Route>
          <Route path='/profile/notes/' dataHolder={dH} element={<ProfileNoteComponent />}></Route>
          <Route path='/profile/notes/:page/' dataHolder={dH} element={<ProfileNoteComponent />}></Route>
          <Route path='/profile/note/' dataHolder={dH} element={<ProfileNoteFormComponent />}></Route>
          <Route path='/profile/mydocs/' dataHolder={dH} element={<AccountPrePrints />}></Route>
          <Route path='/profile/preprint/' dataHolder={dH} element={<AccountPrePrintSubmit type={1} />}></Route>
          <Route path='/profile/preprint/:id/' dataHolder={dH} element={<AccountPrePrintSubmit type={1} />}></Route>
          <Route path='/profile/thesis/' dataHolder={dH} element={<AccountPrePrintSubmit type={2} />}></Route>
          <Route path='/profile/thesis/:id/' dataHolder={dH} element={<AccountPrePrintSubmit type={2} />}></Route>
          <Route path='/profile/research/' dataHolder={dH} element={<AccountPrePrintSubmit type={3} />}></Route>
          <Route path='/profile/research/:id/' dataHolder={dH} element={<AccountPrePrintSubmit type={3} />}></Route>
          <Route path='/profile/book/' dataHolder={dH} element={<AccountPrePrintSubmit type={4} />}></Route>
          <Route path='/profile/book/:id/' dataHolder={dH} element={<AccountPrePrintSubmit type={4} />}></Route>
          <Route path='/profile/note/:id/' dataHolder={dH} element={<ProfileNoteFormComponent />}></Route>
          <Route path="/profile/financial/" dataHolder={dH} element={<AccountFinancial />}></Route>
          <Route path="/profile/cash/:page/" dataHolder={dH} element={<AccountCash />}></Route>
          <Route path="/profile/cash/" dataHolder={dH} element={<AccountCash />}></Route>          
          <Route path="/profile/requests/:page/" dataHolder={dH} element={<AccountRequest />}></Route>
          <Route path="/profile/requests/" dataHolder={dH} element={<AccountRequest />}></Route>          
          <Route path="/profile/invites/:page/" dataHolder={dH} element={<AccountInvites />}></Route>
          <Route path="/profile/invites/" dataHolder={dH} element={<AccountInvites />}></Route>
          <Route path="/profile/giftcards/" dataHolder={dH} element={<AccountGiftCards/>}></Route>
          <Route path="/profile/comments/sent/:page/" dataHolder={dH} element={<AccountComments type={1} />}></Route>
          <Route path="/profile/comments/sent/" dataHolder={dH} element={<AccountComments type={1} />}></Route>
          <Route path="/profile/comments/received/:page/" dataHolder={dH} element={<AccountComments type={2} />}></Route>
          <Route path="/profile/comments/received/" dataHolder={dH} element={<AccountComments type={2} />}></Route>
          <Route path="/profile/questionnaires/" dataHolder={dH} element={<AccountQuestionnaires />}></Route>
          <Route path="/profile/questionnaire/" dataHolder={dH} element={<AccountQuestionnaire />}></Route>
          <Route path="/profile/questionnaire/:id/" dataHolder={dH} element={<AccountQuestionnaire />}></Route>
          <Route path="/profile/confirm/:token/" dataHolder={dH} element={<ProfileConfirm />}></Route>
          <Route path="/q/:id/embeded/" dataHolder={dH} element={<Questionnaire embeded={true} />}></Route>
          <Route path="/q/:id/" dataHolder={dH} element={<Questionnaire embeded={false} />}></Route>          
          <Route path='/alumni/:person_id/' dataHolder={dH} element={<UniStd stdMode={2}/>}></Route>
          <Route path='/alumni/:person_id/:filter/' dataHolder={dH} element={<UniStd stdMode={2}/>}></Route>
          <Route path='/std/:person_id/' dataHolder={dH} element={<UniStd stdMode={1}/>}></Route>
          <Route path='/std/:person_id/:filter/' dataHolder={dH} element={<UniStd stdMode={1}/>}></Route>
          <Route path='/prof/:person_id/' dataHolder={dH} element={<UniProf/>}></Route>
          <Route path='/prof/:person_id/:filter/' dataHolder={dH} element={<UniProf/>}></Route>
          <Route path='/mining/' dataHolder={dH} element={<Mining/>}></Route>
          <Route path='/research/' dataHolder={dH} element={<Research/>}></Route>
          <Route path='/payment/verify/:bank_name/' dataHolder={dH} element={<PaymentVerify/>}></Route>
          <Route path='/certificate/order/done/' dataHolder={dH} element={<CertificateOrderDone/>}></Route>          
          <Route path="*" dataHolder={dH} element={<Navigate to="/404/" />}></Route>           
        </Routes>
      </Suspense>
    );
  }
}
export default Site;